import {useEffect, useState} from 'react';

import {ComOrganizationList, CloudOrganization, UserSource, CurrentUser} from '~shared/models';

import {i18n} from '~ui/modules/app-hi-there/components/ChangeContext/i18n';

import toaster from '~ui/utils/toaster';
import {sdk} from '~ui/services/sdk';

export function useGetOrganizations(user: CurrentUser) {
    const [data, setData] = useState<{
        organizations: CloudOrganization[];
        comOrganizations: ComOrganizationList;
        currentOrgId: string;
    }>({
        comOrganizations: {
            active: [],
            inactive: [],
        },
        currentOrgId: '',
        organizations: [],
    });

    useEffect(() => {
        const promise = sdk.com
            .listOrganizations({
                userIdentity: {
                    src: user.passportId ? UserSource.Passport : UserSource.Cloud,
                    id: user.passportId ? user.passportId : user.uid,
                },
            })
            .then((comOrganizations) => {
                const organizations = [];

                for (const {identity, title} of comOrganizations?.inactive || []) {
                    organizations.push({
                        id: identity.id,
                        title,
                        name: title,
                    });
                }

                for (const {display_name: title, collab_id: id} of comOrganizations?.active || []) {
                    organizations.push({
                        id,
                        title,
                        name: title,
                    });
                }

                let currentOrgId = '';

                if (
                    user.collabOrgId &&
                    comOrganizations?.active.some?.(
                        ({collab_id: collabId}) => collabId === user.collabOrgId,
                    )
                ) {
                    currentOrgId = user.collabOrgId;
                }

                setData({
                    organizations: organizations as CloudOrganization[],
                    comOrganizations,
                    currentOrgId,
                });
            })
            .catch((error) => {
                console.error(error);

                if (error.isCancelled) {
                    return;
                }

                toaster.createToast({
                    type: 'error',
                    name: 'fetchOrganizations',
                    title: i18n('error-fetch-organizations'),
                });
            });

        return () => promise.cancel();
    }, [user.orgId, user.organizations, user.collabOrgId, user.passportId, user.uid]);

    return {
        organizations: data.organizations,
        comOrganizations: data.comOrganizations,
        currentOrgId: data.currentOrgId,
    };
}
